import ModalDeleteFilled from '../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteWorkSheetProductStatusProps extends ModalEditComponentProps { }

const ModalDeleteWorkSheetProductStatus: React.FC<ModalDeleteWorkSheetProductStatusProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/sell/workSheet/workSheetProductStatus/deleteWorkSheetProductStatus',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteWorkSheetProductStatus', '¿Seguro quieres eliminar este estado de hoja de trabajo?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteWorkSheetProductStatus